import { match } from 'ts-pattern';

import { resolveUserErrorCode } from '@/entities/user';

export function resolveEmailUpdateError(error: unknown): string | undefined {
    return match(resolveUserErrorCode(error))
        .with('EMAIL_UNCHANGED', () => 'This is already your email address')
        .with('EMAIL_UNAVAILABLE', () => 'This email address is unavailable')
        .otherwise(() => undefined);
}
